import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import CardRequiredAlert from "~/components/autopto/cardDialog/CardRequiredAlert";
import { isAutoptoCardRequired } from "~/components/autopto/isAutoptoTrial";
import Breadcrumbs from "~/components/ui/breadcrumbs/Breadcrumbs";
import { AlertCard } from "~/components/ui/card/AlertCard.tsx";
import { PAGE_TITLES } from "~/configs/pageTitles";
import { useTeam } from "~/contexts/TeamProvider";
import { usePageTitle } from "~/hooks/usePageTitle";
import { PATTERNS } from "~/router";

import NewSite from "../../components/dashboard/newSite/NewSite";
import styles from "./styles.module.scss";

const NewSitePage = () => {
  usePageTitle(PAGE_TITLES.addSite);
  const { team } = useTeam();
  const { pathname } = useLocation();
  const [warningText, setWarningText] = useState<string | null>(null);
  const [siteName, setSiteName] = useState<string | null>(null);

  const fakeBreadcrumbs = [
    { title: PAGE_TITLES.dashboard, link: "/" },
    { title: PAGE_TITLES.addSite, link: "/sites/wizard/new" },
    ...(siteName ? [{ title: siteName, link: pathname }] : []),
  ];

  return (
    <div className={styles.page}>
      {warningText && isAutoptoCardRequired(team) && (
        <CardRequiredAlert
          title="Add more sites with a card"
          content="You've reached the trial's site limit. A card lifts the trial limits to your plan's."
        />
      )}
      {warningText && !isAutoptoCardRequired(team) && (
        <AlertCard
          title="Upgrade Required"
          type="neutral"
          content={
            <>
              You have reached your current plan quota, please upgrade to add
              more sites.
            </>
          }
          actions={
            <>
              <Link
                className={styles.link}
                to={PATTERNS.billingSubscriptionEdit}
              >
                Upgrade
              </Link>
            </>
          }
        />
      )}
      <h1 className={styles.title}>{PAGE_TITLES.addSite}</h1>
      <>
        {fakeBreadcrumbs.length && (
          <Breadcrumbs fakeBreadcrumbs={fakeBreadcrumbs} />
        )}
      </>
      <NewSite setWarningText={setWarningText} setSiteName={setSiteName} />
    </div>
  );
};
export default NewSitePage;
